import Component from '../Component';
import $ from '../../vendor/CustomJquery';

export default class PriceTable extends Component {

  configure() {
    return super.configure();
  }

  initialize() {

    this.form = $('.is-with-price-list-form');
    this.city = this.form.find('select[name="city_id"]');
    this.autoState = this.form.find('input[type="checkbox"][name="prices_automatic_state"]');
    this.priceList = this.form.find('.is-price-list-table tr');

    this.subscribeToEvents();
    return super.initialize();
  }

  subscribeToEvents() {
    this.trackCityChanges();
    this.trackInputChanges();
    this.trackPriceListState();
  }

  trackCityChanges() {

    this.city.off('change');
    this.city.change((event) => {

      let element = $(event.currentTarget);
      let currentCity = parseInt( element.val() ),
          currentCountry = parseInt( this.city.find('option:selected').data('country') );

      if (currentCity === 0 || this.autoState.prop('checked') === false) {
        return false;
      }

      this.priceList.each((index, element) => {

        let app = $(element),
            id = parseInt( app.data('appId') ),
            countryId = parseInt( app.data('appCountry') ),
            cityId = parseInt( app.data('appCity')  ),
            isFree = parseInt( app.data('appIsFree') ),
            price = app.find('input[name="prices['+ id +'][price]"]'),
            productId = app.find('input[name="prices['+ id +'][product_id]"]');

        let isForSale = false,
            isAvailable = false; // (isFree == 1);

        // Основные приложения Азбо: iOS (№1), Android (№2)
        if ([1, 2].indexOf(id) >= 0
          || (isFree === 1 &&
            (
              (countryId.length === 0 && cityId.length === 0)
              || (countryId == currentCountry)
              || (cityId == currentCity)
            )
          )
        ) {
          isAvailable = true;
          if (parseInt(price.val()) > 0 && productId.val() != '') isForSale = true;
        }

        // yarry [19:40] 21-12-2015 / Slack
        // Для Aita - нужно все бесплатные проставить isAvailable
        if (id === 1000 && (price.val() == 0 || productId.val() === '')) isAvailable = true;

        app.find('input[type="checkbox"][name="prices['+ id +'][is_available]"]')
          .prop('checked', isAvailable).trigger('change');

        app.find('input[type="checkbox"][name="prices['+ id +'][is_for_sale]"]')
          .prop('checked', isForSale).trigger('change');

      });

    });

  }

  trackInputChanges() {

    $.each(['product_id', 'price', 'discount_price', 'discount_price_period'], (index, name) => {

      let input = this.form.find('input[name="'+ name +'"]'),
          autoFilling = input.closest('.field-body').find('input[name^="auto_fill"]');

      input.off('keyup change');
      input.on('keyup change', (event) => {

        let element = $(event.currentTarget),
            value = element.val();

        if (element.data('value') == value) return;

        element.data('value', value);

        if (name === 'product_id') {

          value = value.replace('-', '_');
          value = value.replace(/[^a-z0-9_\.]/gmi, '');

        } else if (['price', 'discount_price'].indexOf(name) >= 0) {

          value = value.replace(/,/g, '.');
          value = value.replace(/[^0-9\.]/gmi, '');

        }

        element.val(value);

        if (autoFilling.prop('checked') === true) {
          this.updatePrice(name, value);
        }

      });

      autoFilling.on('change', function(){
        if ($(this).prop('checked') === true) input.change();
      });

    });

  }

  trackPriceListState() {

    this.priceList.find('input[type="checkbox"]').change((event) => {

      let element = $(event.currentTarget);

      let name = (/\[(\1[_a-z]*)\]/g.exec(element.attr('name'))[1]).replace(/_/g, '-'),
          value = element.is(':checked') ? 1 : 0;

      element.closest('tr').attr('data-' + name, value);

    }).change();

  }

  updatePrice(param, value) {

    this.priceList.each((index, element) => {

      let app = $(element),
          id = parseInt(app.data('app-id')),
          countryId = parseInt(app.data('appCountry')),
          cityId = parseInt(app.data('appCity')),
          isFree = parseInt(app.data('appIsFree')),
          price = app.find('input[name="prices['+ id +'][price]"]'),
          productId = app.find('input[name="prices['+ id +'][product_id]"]'),
          compiledValue = value;

      let currentCity = parseInt( this.city.val() ),
          currentCountry = this.city.find('option:selected').data('country');

      if (typeof param === 'string') {

        if (param === 'product_id') {

          let prefix = '';

          if (typeof app.data('appPrefix') !== 'undefined' && app.data('appPrefix').length > 0) {
            prefix = app.data('appPrefix') + '.';
          }

          compiledValue = prefix + compiledValue;

          if (value.length === 0) compiledValue = '';

          if (parseInt( app.data('appProductIdPermanent') ) === 1) {
            compiledValue = app.data('appPrefix');
          }

        }

        app.find('input[name="prices['+ id +']['+ param +']"]').val(compiledValue);

        if (this.autoState.prop('checked') === false) return;

        let isForSale = false,
            isAvailable = false; // (isFree == 1);

        // Основные приложения Азбо: iOS (№1), Android (№2)
        if (
          [1, 2].indexOf(id) >= 0
          || (
              isFree === 1
              && (
                (countryId.length === 0 && cityId.length === 0)
                || (countryId == currentCountry)
                || (cityId === currentCity)
              )
          )
        ) {
          isAvailable = true;
          if (parseFloat(price.val()) > 0 && productId.val() !== '') {
            isForSale = true;
          }
        }

        // yarry [19:40] 21-12-2015 / Slack
        // Для Aita - нужно все бесплатные проставить isAvailable
        if (id === 1000 && (parseFloat(price.val()) === 0 || productId.val() === '')) {
          isAvailable = true;
        }

        app.find('input[type="checkbox"][name="prices['+ id +'][is_available]"]')
          .prop('checked', isAvailable).trigger('change');

        app.find('input[type="checkbox"][name="prices['+ id +'][is_for_sale]"]')
          .prop('checked', isForSale).trigger('change');

      }

    });

  }
}